import { FC, Fragment, useEffect } from "react";
import { useDidMount } from "rooks";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { homeDashboardSelector } from "@/store/dashboards/selectors/home/homeDashboardSelector";
import { DashboardLayout } from "@/components/pages/dashboard/components/DashboardLayout";
import { DashboardFilters } from "@/components/pages/dashboard/components/filters/DashboardFilters";
import { WidgetCreateDrawer } from "@/components/pages/dashboard/components/adding-widget/widget-create/WidgetCreateDrawer";
import { WidgetSelectDrawer } from "@/components/pages/dashboard/components/adding-widget/widget-select/WidgetSelectDrawer";
import { getDashboardByIdAndUpdateLayoutThunk } from "@/store/dashboards/thunks/dashboard/getDashboardByIdAndUpdateLayoutThunk";
import { resetExplainWithAI } from "@/store/explain-with-ai/explainWithAiSlice";
import { getAllReportsThunk } from "@/store/reports/thunks/getAllReportsThunk";
import { HomeDashboardHeader } from "@/components/pages/dashboard/home-page/HomeDashboardHeader";
import { EmptyHomeDashboardPage } from "@/components/pages/dashboard/home-page/EmptyHomeDashboardPage";
import { dashboardHierarchyVisibilitiesLoadingSelector } from "@/store/dashboards/selectors/dashboard-hierarchy-visibility/dashboardHierarchyVisibilitiesLoadingSelector";

export const HomeDashboardPage: FC = () => {
  const dispatch = useAppDispatch();

  const dashboard = useAppSelector(homeDashboardSelector);
  const loading = useAppSelector(dashboardHierarchyVisibilitiesLoadingSelector);

  const dashboardId = dashboard?.id;

  useEffect(() => {
    if (dashboardId) {
      dispatch(getDashboardByIdAndUpdateLayoutThunk(dashboardId));
      dispatch(resetExplainWithAI());
    }
  }, [dashboardId, dispatch]);

  useDidMount(() => {
    dispatch(getAllReportsThunk());
  });

  return (
    <Fragment>
      <HomeDashboardHeader dashboardId={dashboardId} />

      {!loading && (
        <Fragment>
          {dashboardId ? (
            <Fragment key={dashboardId}>
              <DashboardFilters showDashboardSelect dashboardId={dashboardId} />
              <DashboardLayout dashboardId={dashboardId} />
            </Fragment>
          ) : (
            <EmptyHomeDashboardPage />
          )}
        </Fragment>
      )}

      <WidgetCreateDrawer />
      <WidgetSelectDrawer />
    </Fragment>
  );
};
